export default __webpack_public_path__ + "static/media/SourceSansPro-Regular.581fb367.woff";